import Layout from "../../components/Layout";
import { useUserState } from "../../context/UserContext";
import AdminTimeTable from "./admin/AdminTimeTable";
import UserTimeTable from "./user/UserTimeTable";
import StudentTimeTable from "./student/StudentTimeTable";
import Permission from "../error/Permission";

const index = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role_type === "school_admin" ? (
          <AdminTimeTable />
        ) : userRole?.role_type === "employee" ? <UserTimeTable /> : userRole?.role_type === "student" ? <StudentTimeTable /> : <Permission />}
      </>
    }
    />
  );
};

export default index;
